/**
 * Cálculo de linha e de documento comercial.
 *
 * Mora no domínio porque roda nos três lugares: o servidor grava, a web mostra
 * enquanto digita, e o app de pátio monta pedido offline. Uma implementação,
 * um arredondamento.
 */
import { cubarTolerante } from "./cubagem.js";
import { Dinheiro, Preco, Volume } from "./grandezas.js";
/**
 * Calcula uma linha: cuba pela regra do documento e multiplica pelo preço.
 *
 * Tolerante por design — linha incompleta é estado normal de digitação, e quem
 * recusa o documento é o F9 (design §5.2), não cada tecla.
 */
export function calcularLinha(regra, linha) {
    const cubagem = cubarTolerante(regra, linha.medida);
    if (!cubagem.ok)
        return { ok: false, erro: cubagem.erro };
    let preco;
    try {
        preco = Preco.deReais(linha.precoUnitario, "Preço/m³");
    }
    catch (e) {
        return { ok: false, erro: e instanceof Error ? e.message : "preço inválido" };
    }
    /**
     * Preço zero não é venda, é doação — e passava calado.
     *
     * O campo em branco vira zero, o cálculo fecha (qualquer volume × 0 = 0),
     * a validação dizia "0 pendências" e o orçamento convertia em pedido de
     * graça. Só aparecia quando o dinheiro não entrava.
     *
     * Recusar aqui, e não na tela, vale para todo caminho: web, app de pátio
     * e qualquer chamada direta à API.
     */
    if (!preco.interno().isPositive() || preco.interno().isZero()) {
        return {
            ok: false,
            erro: "informe o preço por m³ — linha com preço zerado não é orçamento",
        };
    }
    return {
        ok: true,
        volume: cubagem.volume,
        preco,
        total: preco.vezesVolume(cubagem.volume),
    };
}
/**
 * Totaliza o documento inteiro.
 *
 * Soma as linhas que fecham e devolve as pendentes separadas, com o índice —
 * é o que a grade precisa para marcar a canaleta da linha certa. Um documento
 * com pendência ainda mostra o total parcial; ele só não pode ser convertido.
 */
export function calcularDocumento(regra, linhas) {
    const pendencias = [];
    let volume = Volume.ZERO;
    let valor = Dinheiro.ZERO;
    let linhasOk = 0;
    linhas.forEach((linha, indice) => {
        const r = calcularLinha(regra, linha);
        if (!r.ok) {
            pendencias.push({ indice, erro: r.erro });
            return;
        }
        volume = volume.mais(r.volume);
        valor = valor.mais(r.total);
        linhasOk++;
    });
    return { volume, valor, linhasOk, pendencias };
}
/**
 * O saldo de pátio atende esta linha?
 *
 * Compara contra o DISPONÍVEL (pátio menos reservado por pedido aberto), não
 * contra o saldo bruto — vender duas vezes o mesmo lote é o erro que a reserva
 * existe para evitar.
 */
export function atendeSaldo(necessario, disponivel) {
    return disponivel.maiorOuIgual(necessario);
}
//# sourceMappingURL=documento.js.map